import get from 'lodash/get';
import { getRentals, getRentalsAggregations, setStartAggregationAction, cleanRentalsAggregations } from './actions';
import { PRODUCTION_RENTALS_AGGREGATION_TYPES } from '../../constants/consts';
import { listReducer, namedListParams } from '../../utils/crudUtils';

export const key = 'Rentals';

export const initialState = {
  rentals: namedListParams('rentals'),
  operas: [],
  operasLoading: false,
  operasError: null,
  teams: [],
  teamsLoading: false,
  teamsError: null,
  companies: [],
  companiesLoading: false,
  companiesError: null,
  startAggregations: false,
};

const rentalsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getRentals.TRIGGER:
    case getRentals.SUCCESS:
    case getRentals.FAILURE:
      return listReducer(state, type, payload, initialState.rentals.listName);

    case setStartAggregationAction.TRIGGER:
      return { ...state, startAggregations: true };

    case getRentalsAggregations.TRIGGER:
      return getRentalsAggregationsTriggerState(payload, state);

    case getRentalsAggregations.SUCCESS:
      return getRentalsAggregationsSuccessfulState(payload, state);

    case getRentalsAggregations.FAILURE:
      return getRentalsAggregationsFailureState(payload, state);

    case cleanRentalsAggregations.TRIGGER:
      return { ...state, [payload]: [] };

    default:
      return state;
  }
};

export default rentalsReducer;

function getRentalsAggregationsTriggerState(payload, state) {
  const { type } = payload;
  switch (type) {
    case PRODUCTION_RENTALS_AGGREGATION_TYPES.WORK_ID:
      return {
        ...state,
        operas: [],
        operasLoading: true,
        operasError: null,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.PRODUCTION_TEAM:
      return {
        ...state,
        teams: [],
        teamsLoading: true,
        teamsError: null,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.COMPANY:
      return {
        ...state,
        companies: [],
        companiesLoading: true,
        companiesError: null,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.SORT:
      return {
        ...state,
        sorts: [],
        sortsLoading: true,
        sortsError: null,
      };

    default:
      return state;
  }
}

function getRentalsAggregationsSuccessfulState(payload, state) {
  const aggregationType = get(payload, 'criteria.aggregation_type');
  const data = get(payload, 'data', []);
  switch (aggregationType) {
    case PRODUCTION_RENTALS_AGGREGATION_TYPES.WORK_ID:
      return {
        ...state,
        operas: data,
        startAggregations: false,
        operasLoading: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.PRODUCTION_TEAM:
      return {
        ...state,
        teams: data,
        startAggregations: false,
        teamsLoading: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.COMPANY:
      return {
        ...state,
        companies: data,
        companiesLoading: false,
        startAggregations: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.SORT:
      return {
        ...state,
        sorts: data,
        sortsLoading: false,
        startAggregations: false,
      };

    default:
      return state;
  }
}

function getRentalsAggregationsFailureState(payload, state) {
  switch (payload.type) {
    case PRODUCTION_RENTALS_AGGREGATION_TYPES.WORK_ID:
      return {
        ...state,
        operas: [],
        operasLoading: false,
        operasError: payload,
        startAggregations: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.PRODUCTION_TEAM:
      return {
        ...state,
        teams: [],
        teamsLoading: false,
        teamsError: payload,
        startAggregations: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.COMPANY:
      return {
        ...state,
        companies: [],
        companiesLoading: false,
        companiesError: payload,
        startAggregations: false,
      };

    case PRODUCTION_RENTALS_AGGREGATION_TYPES.SORT:
      return {
        ...state,
        sorts: [],
        sortsLoading: false,
        sortsError: payload,
        startAggregations: false,
      };

    default:
      return state;
  }
}
